var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "stepper__subtitle mt-3" }, [
        _vm._v("Autorizó el Tratamiendo de "),
        _c(
          "a",
          { attrs: { href: "javascript:void(0)" }, on: { click: _vm.showLaw } },
          [_vm._v("Datos Personales y envío de promociones")]
        )
      ]),
      _c(
        "v-radio-group",
        {
          attrs: { row: "" },
          on: {
            input: function($event) {
              _vm.$emit("input", $event)
            }
          },
          model: {
            value: _vm.authorizePersonalDataTreatment,
            callback: function($$v) {
              _vm.authorizePersonalDataTreatment = $$v
            },
            expression: "authorizePersonalDataTreatment"
          }
        },
        [
          _c("v-radio", { attrs: { label: "Sí", value: "S" } }),
          _c("v-radio", { attrs: { label: "No", value: "N" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2ff97dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ff97dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/personal-data-treatment-radio.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d2ff97dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/personal-data-treatment-radio.vue
// module chunks = 0 1 2 3